export default "dist/images/c7164b072d62c91c27c6d607b5207e7b.png";